/* global axios */
import ApiClient from './ApiClient';

class BoardsAPI extends ApiClient {
  constructor() {
    super('boards', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  getBoard(boardId) {
    return axios.get(`${this.url}/${boardId}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(boardId, data) {
    return axios.patch(`${this.url}/${boardId}`, data);
  }

  delete(boardId) {
    return axios.delete(`${this.url}/${boardId}`);
  }

  // Stages
  createStage(boardId, data) {
    return axios.post(`${this.url}/${boardId}/stages`, data);
  }

  updateStage(boardId, stageId, data) {
    return axios.patch(`${this.url}/${boardId}/stages/${stageId}`, data);
  }

  deleteStage(boardId, stageId) {
    return axios.delete(`${this.url}/${boardId}/stages/${stageId}`);
  }

  reorderStages(boardId, stages) {
    return axios.post(`${this.url}/reorder`, { board_id: boardId, stages });
  }

  // Deals
  createDeal(boardId, data) {
    return axios.post(`${this.url}/${boardId}/deals`, data);
  }

  updateDeal(boardId, dealId, data) {
    return axios.patch(`${this.url}/${boardId}/deals/${dealId}`, data);
  }

  deleteDeal(boardId, dealId) {
    return axios.delete(`${this.url}/${boardId}/deals/${dealId}`);
  }

  moveDeal(boardId, dealId, stageId, position) {
    return axios.post(`${this.url}/${boardId}/deals/${dealId}/move`, {
      stage_id: stageId,
      position,
    });
  }

  linkConversation(boardId, dealId, conversationId) {
    return axios.post(
      `${this.url}/${boardId}/deals/${dealId}/link_conversation`,
      { conversation_id: conversationId }
    );
  }

  unlinkConversation(boardId, dealId, conversationId) {
    return axios.delete(
      `${this.url}/${boardId}/deals/${dealId}/unlink_conversation`,
      { data: { conversation_id: conversationId } }
    );
  }
}

export default new BoardsAPI();
